export type SiteConfig = typeof siteConfig;

export const siteConfig = () => ({
  needCookieConsent: true,
  links: {
    github: "https://github.com/jkdevcode",
  },
});
